import React from 'react'
import { Text, View, StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { Spacer } from '../atoms'
import { useResponsive } from '../../utils/hooks'
import { LogoDark } from '../../assets/icons'

export const PoweredByBluetape = () => {
  const { sm } = useResponsive()
  const { t } = useTranslation('auth')
  return (
    <View style={styles.viewLeft} testID="poweredByBluetape">
      <Text
        style={composeStyle(styles.poweredBy, !sm && styles.poweredByMobile)}
      >
        {t('poweredBy')}
      </Text>
      <Spacer height={sm ? 5 : 2} />
      <LogoDark width={sm ? 165 : 95} height={sm ? 21 : 12} />
    </View>
  )
}

const styles = StyleSheet.create({
  viewLeft: {
    alignItems: 'flex-end',
  },
  poweredBy: {
    fontWeight: '400',
    fontSize: 16,
    lineHeight: 19,
    color: '#003353',
  },
  poweredByMobile: {
    fontSize: 9,
    lineHeight: 10,
  },
})
